function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomtext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 855.79 29.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.27,26.41h-3.88l-3.01-7.9H6.5l-2.87,7.9H0L9.97.44h3.7l10.59,25.97ZM16.37,15.78L11.8,3.74l-4.36,12.05h8.93Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.64,26.86c-3.67,0-6.61-1.21-8.8-3.62-2.19-2.42-3.29-5.69-3.29-9.81s1.1-7.39,3.29-9.81c2.19-2.42,5.12-3.62,8.8-3.62,2.82,0,5.23.76,7.21,2.28s3.1,3.53,3.35,6.02h-3.54c-.14-1.64-.85-2.95-2.14-3.91-1.28-.97-2.9-1.46-4.84-1.46-2.63,0-4.72.91-6.25,2.72s-2.3,4.4-2.3,7.77.76,5.94,2.29,7.76c1.52,1.82,3.59,2.73,6.2,2.73,2.03,0,3.67-.5,4.93-1.49s1.96-2.41,2.13-4.25h3.54c-.25,2.76-1.34,4.9-3.26,6.42-1.92,1.51-4.36,2.27-7.3,2.27Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.46,26.86c-3.67,0-6.61-1.21-8.8-3.62-2.19-2.42-3.29-5.69-3.29-9.81s1.1-7.39,3.29-9.81c2.19-2.42,5.12-3.62,8.8-3.62,2.82,0,5.23.76,7.21,2.28s3.1,3.53,3.35,6.02h-3.54c-.14-1.64-.85-2.95-2.14-3.91-1.28-.97-2.9-1.46-4.84-1.46-2.63,0-4.72.91-6.25,2.72s-2.3,4.4-2.3,7.77.76,5.94,2.29,7.76c1.52,1.82,3.59,2.73,6.2,2.73,2.03,0,3.67-.5,4.93-1.49s1.96-2.41,2.13-4.25h3.54c-.25,2.76-1.34,4.9-3.26,6.42-1.92,1.51-4.36,2.27-7.3,2.27Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.65,0c3.64,0,6.61,1.23,8.93,3.69,2.31,2.45,3.47,5.7,3.47,9.74s-1.16,7.29-3.47,9.75c-2.31,2.45-5.29,3.69-8.93,3.69s-6.64-1.23-8.96-3.69c-2.33-2.46-3.49-5.71-3.49-9.74s1.16-7.29,3.49-9.74c2.33-2.46,5.32-3.69,8.96-3.69ZM92.62,23.92c2.6,0,4.73-.92,6.39-2.76,1.66-1.84,2.49-4.42,2.49-7.72s-.83-5.88-2.48-7.72-3.76-2.76-6.33-2.76-4.75.92-6.42,2.76c-1.67,1.84-2.51,4.42-2.51,7.72s.83,5.87,2.5,7.72,3.79,2.77,6.36,2.77Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.43,26.86c-3.01,0-5.27-.59-6.76-1.76-1.49-1.17-2.44-2.54-2.83-4.13-.39-1.58-.59-3.42-.59-5.51V.44h3.44v14.97c0,3.41.57,5.66,1.72,6.73,1.15,1.08,2.82,1.61,5.03,1.61s3.89-.54,5.03-1.61c1.15-1.07,1.72-3.32,1.72-6.73V.44h3.45v15.02c0,3.14-.38,5.46-1.13,6.95-.75,1.49-1.88,2.6-3.39,3.34s-3.41,1.11-5.69,1.11Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.45,26.41h-3.53l-13.61-20.5v20.5h-3.26V.44h3.51l13.61,20.5V.44h3.28v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34,3.52h-8.59v22.89h-3.45V3.52h-8.52V.44h20.57v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.54,26.41h-3.45V.44h3.45v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.75,26.41h-3.53l-13.61-20.5v20.5h-3.26V.44h3.51l13.61,20.5V.44h3.28v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.54,26.86c-3.73,0-6.76-1.22-9.08-3.67-2.32-2.44-3.48-5.7-3.48-9.76s1.15-7.33,3.44-9.77,5.3-3.66,9.02-3.66c3.13,0,5.73.75,7.8,2.26,2.07,1.5,3.23,3.52,3.48,6.05h-3.56c-.14-1.68-.9-2.99-2.27-3.94s-3.18-1.43-5.42-1.43c-2.68,0-4.84.92-6.48,2.75-1.63,1.83-2.45,4.41-2.45,7.74s.83,5.9,2.48,7.73,3.82,2.75,6.48,2.75c8.56,0,8.34-7.65,8.34-7.65h-9.59v-3.1h12.92c0,6.8-3.12,13.7-11.64,13.7Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.72,26.86c-3.73,0-6.76-1.22-9.08-3.67-2.32-2.44-3.48-5.7-3.48-9.76s1.15-7.33,3.44-9.77,5.3-3.66,9.02-3.66c3.13,0,5.73.75,7.8,2.26,2.07,1.5,3.23,3.52,3.48,6.05h-3.56c-.14-1.68-.9-2.99-2.27-3.94s-3.18-1.43-5.42-1.43c-2.68,0-4.84.92-6.48,2.75-1.63,1.83-2.45,4.41-2.45,7.74s.83,5.9,2.48,7.73,3.82,2.75,6.48,2.75c8.56,0,8.34-7.65,8.34-7.65h-9.59v-3.1h12.92c0,6.8-3.12,13.7-11.64,13.7Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.08,26.86c-3.73,0-6.76-1.22-9.08-3.67-2.32-2.44-3.48-5.7-3.48-9.76s1.15-7.33,3.44-9.77,5.3-3.66,9.02-3.66c3.13,0,5.73.75,7.8,2.26,2.07,1.5,3.23,3.52,3.48,6.05h-3.56c-.14-1.68-.9-2.99-2.27-3.94s-3.18-1.43-5.42-1.43c-2.68,0-4.84.92-6.48,2.75-1.63,1.83-2.45,4.41-2.45,7.74s.83,5.9,2.48,7.73,3.82,2.75,6.48,2.75c8.56,0,8.34-7.65,8.34-7.65h-9.59v-3.1h12.92c0,6.8-3.12,13.7-11.64,13.7Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.48,26.86c-3.67,0-6.61-1.21-8.8-3.62-2.19-2.42-3.29-5.69-3.29-9.81s1.1-7.39,3.29-9.81c2.19-2.42,5.12-3.62,8.8-3.62,2.82,0,5.23.76,7.21,2.28s3.1,3.53,3.35,6.02h-3.54c-.14-1.64-.85-2.95-2.14-3.91-1.28-.97-2.9-1.46-4.84-1.46-2.63,0-4.72.91-6.25,2.72s-2.3,4.4-2.3,7.77.76,5.94,2.29,7.76c1.52,1.82,3.59,2.73,6.2,2.73,2.03,0,3.67-.5,4.93-1.49s1.96-2.41,2.13-4.25h3.54c-.25,2.76-1.34,4.9-3.26,6.42-1.92,1.51-4.36,2.27-7.3,2.27Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.62,0c3.64,0,6.61,1.23,8.93,3.69,2.31,2.45,3.47,5.7,3.47,9.74s-1.16,7.29-3.47,9.75c-2.31,2.45-5.29,3.69-8.93,3.69s-6.64-1.23-8.96-3.69c-2.33-2.46-3.49-5.71-3.49-9.74s1.16-7.29,3.49-9.74c2.33-2.46,5.32-3.69,8.96-3.69ZM326.59,23.92c2.6,0,4.73-.92,6.39-2.76,1.66-1.84,2.49-4.42,2.49-7.72s-.83-5.88-2.48-7.72-3.76-2.76-6.33-2.76-4.75.92-6.42,2.76c-1.67,1.84-2.51,4.42-2.51,7.72s.83,5.87,2.5,7.72,3.79,2.77,6.36,2.77Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.55,26.41h-3.53l-13.61-20.5v20.5h-3.26V.44h3.51l13.61,20.5V.44h3.28v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.73,26.86c-3.66,0-6.4-.82-8.21-2.46-1.81-1.64-2.77-3.75-2.86-6.32h3.31c.18,1.94.98,3.37,2.42,4.29,1.44.93,3.17,1.39,5.2,1.39,1.92,0,3.48-.4,4.65-1.19,1.18-.79,1.76-1.87,1.76-3.22,0-1.43-.61-2.47-1.82-3.12-1.22-.65-3.31-1.29-6.28-1.92-2.97-.63-5.1-1.51-6.39-2.63-1.29-1.12-1.94-2.62-1.94-4.48,0-2.1.84-3.83,2.52-5.17,1.68-1.35,3.92-2.02,6.71-2.02,2.93,0,5.29.68,7.09,2.04s2.75,3.28,2.85,5.76h-3.35c-.34-3.14-2.49-4.72-6.45-4.72-1.91,0-3.4.36-4.45,1.08s-1.58,1.68-1.58,2.87c0,1.09.42,1.9,1.27,2.44.85.54,2.42,1.07,4.73,1.58,2.31.51,4.14,1.01,5.5,1.5s2.52,1.27,3.49,2.31c.97,1.04,1.45,2.45,1.45,4.21,0,2.23-.89,4.09-2.67,5.56-1.78,1.48-4.09,2.22-6.95,2.22Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.88,26.86c-3.01,0-5.27-.59-6.76-1.76-1.49-1.17-2.44-2.54-2.83-4.13-.39-1.58-.59-3.42-.59-5.51V.44h3.44v14.97c0,3.41.57,5.66,1.72,6.73,1.15,1.08,2.82,1.61,5.03,1.61s3.89-.54,5.03-1.61c1.15-1.07,1.72-3.32,1.72-6.73V.44h3.45v15.02c0,3.14-.38,5.46-1.13,6.95-.75,1.49-1.88,2.6-3.39,3.34s-3.41,1.11-5.69,1.11Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.53,26.41h-16.07V.44h3.44v22.89h12.63v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.67,3.52h-8.59v22.89h-3.45V3.52h-8.52V.44h20.57v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.82,26.41h-3.45V.44h3.45v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.98,26.41h-3.53l-13.61-20.5v20.5h-3.26V.44h3.51l13.61,20.5V.44h3.28v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.9,26.4h-4.87s-4.8-11.1-6.12-11.1h-3.52v11.11h-3.44V.44h11.5c2.01,0,3.65.2,4.93.58,1.28.39,2.31,1.21,3.12,2.46s1.2,2.66,1.2,4.24c0,1.79-.52,3.29-1.56,4.5s-2.46,1.99-4.27,2.36l-2.86.06,5.89,11.76ZM591.39,12.22h7.67c2.14,0,3.69-.34,4.65-1.01.96-.67,1.44-1.84,1.44-3.49,0-2.95-1.85-4.43-5.56-4.43h-8.2v8.93Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.84,26.41h-3.88l-3.01-7.9h-10.88l-2.87,7.9h-3.63l9.97-25.97h3.7l10.59,25.97ZM626.94,15.78l-4.57-12.05-4.36,12.05h8.93Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.45,26.41h-3.53l-13.61-20.5v20.5h-3.26V.44h3.51l13.61,20.5V.44h3.28v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.07,3.52h-8.59v22.89h-3.45V3.52h-8.52V.44h20.57v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.91,26.86c-3.66,0-6.4-.82-8.21-2.46-1.81-1.64-2.77-3.75-2.86-6.32h3.31c.18,1.94.98,3.37,2.42,4.29,1.44.93,3.17,1.39,5.2,1.39,1.92,0,3.48-.4,4.65-1.19,1.18-.79,1.76-1.87,1.76-3.22,0-1.43-.61-2.47-1.82-3.12-1.22-.65-3.31-1.29-6.28-1.92-2.97-.63-5.1-1.51-6.39-2.63-1.29-1.12-1.94-2.62-1.94-4.48,0-2.1.84-3.83,2.52-5.17,1.68-1.35,3.92-2.02,6.71-2.02,2.93,0,5.29.68,7.09,2.04s2.75,3.28,2.85,5.76h-3.35c-.34-3.14-2.49-4.72-6.45-4.72-1.91,0-3.4.36-4.45,1.08s-1.58,1.68-1.58,2.87c0,1.09.42,1.9,1.27,2.44.85.54,2.42,1.07,4.73,1.58,2.31.51,4.14,1.01,5.5,1.5s2.52,1.27,3.49,2.31c.97,1.04,1.45,2.45,1.45,4.21,0,2.23-.89,4.09-2.67,5.56-1.78,1.48-4.09,2.22-6.95,2.22Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M759.2,3.52h-8.59v22.89h-3.45V3.52h-8.52V.44h20.57v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.45,26.41h-3.88l-3.01-7.9h-10.88l-2.87,7.9h-3.63l9.97-25.97h3.7l10.59,25.97ZM776.55,15.78l-4.57-12.05-4.36,12.05h8.93Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.66,26.41h-4.22l-7.69-11-7.72,11h-4.22l9.97-13.68-8.98-12.3h4.2l6.71,9.6,6.75-9.6h4.2l-9.02,12.3,10.01,13.68Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.32,26.41h-19.36V.44h18.76v3.08h-15.32v7.94h14.33v3.08h-14.33v8.79h15.93v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.18,26.86c-3.66,0-6.4-.82-8.21-2.46-1.81-1.64-2.76-3.75-2.86-6.32h3.31c.18,1.94.98,3.37,2.42,4.29,1.44.93,3.17,1.39,5.2,1.39,1.92,0,3.48-.4,4.65-1.19,1.18-.79,1.77-1.87,1.77-3.22,0-1.43-.61-2.47-1.83-3.12-1.21-.65-3.31-1.29-6.28-1.92-2.97-.63-5.1-1.51-6.39-2.63-1.29-1.12-1.94-2.62-1.94-4.48,0-2.1.84-3.83,2.52-5.17,1.68-1.35,3.92-2.02,6.71-2.02,2.93,0,5.29.68,7.09,2.04,1.8,1.36,2.75,3.28,2.85,5.76h-3.35c-.34-3.14-2.49-4.72-6.45-4.72-1.91,0-3.4.36-4.45,1.08-1.05.72-1.58,1.68-1.58,2.87,0,1.09.42,1.9,1.27,2.44.85.54,2.42,1.07,4.73,1.58,2.31.51,4.14,1.01,5.5,1.5,1.36.5,2.52,1.27,3.49,2.31.97,1.04,1.45,2.45,1.45,4.21,0,2.23-.89,4.09-2.67,5.56-1.77,1.48-4.09,2.22-6.95,2.22Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 264.42,
    y: 0.44,
    width: 4.73,
    height: 29.32,
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.72,
    y: 0.44,
    width: 4.73,
    height: 29.32,
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 717.99,
    y: 0.44,
    width: 4.73,
    height: 29.32,
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomtext);
export default __webpack_public_path__ + "static/media/bottomtext.2878040ee0097e9f04faceb91fa8f7f6.svg";
export { ForwardRef as ReactComponent };